/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const IsNullResourceId: core.serialization.ObjectSchema<
    serializers.IsNullResourceId.Raw,
    Truvity.IsNullResourceId
> = core.serialization.object({});

export declare namespace IsNullResourceId {
    export interface Raw {}
}
